import { Poly } from './poly';
import { createShape } from './util';
export const Polyline = createShape('polyline', {}, { parent: Poly });
//# sourceMappingURL=polyline.js.map